var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",class:{ 'icon--large': _vm.size === 'large' },attrs:{"role":"presentation"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.icon)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }